import PolicyPage from "./PolicyPage";

export default function PrivacyPolicyPage() {
  return (
    <PolicyPage
      eyebrow="Legal"
      title="Privacy Policy"
      lastUpdated="February 2026"
      testid="page-privacy"
    >
      <p>
        Smibha Luxe Candles (&ldquo;Smibha Luxe Candles,&rdquo; &ldquo;we,&rdquo; &ldquo;our,&rdquo;
        or &ldquo;us&rdquo;) respects your privacy. This Privacy Policy explains how we collect,
        use, share, and protect personal information when you interact with smibhaluxe.com, our
        storefront, and any related services (collectively, the &ldquo;Services&rdquo;).
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        1. Information we collect
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Order &amp; account data:</strong> name, shipping &amp; billing address, email,
          phone number, and order history.
        </li>
        <li>
          <strong>Payment data:</strong> processed securely by Stripe. We never store full card
          numbers on our servers.
        </li>
        <li>
          <strong>Device &amp; usage data:</strong> IP address, browser type, pages viewed, and
          referrer URLs collected via cookies and analytics tools.
        </li>
        <li>
          <strong>Marketing preferences:</strong> the lists you subscribe to and how you engage with
          our emails.
        </li>
      </ul>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        2. How we use your information
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>To fulfil your orders, send shipping updates, and provide customer support.</li>
        <li>To prevent fraud, verify identity, and meet our legal &amp; tax obligations.</li>
        <li>To improve our products, website, and merchandising decisions.</li>
        <li>
          To send marketing emails about new candle drops, seasonal collections, and offers (only with
          your consent — you can unsubscribe anytime via the link in any email).
        </li>
      </ul>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        3. Sharing of information
      </h2>
      <p>
        We share data only with vetted service providers that help us operate the Services —
        including Stripe (payments), Resend (transactional email), Canada Post (shipping), and
        analytics providers. We never sell your personal information.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        4. Cookies
      </h2>
      <p>
        We use first- and third-party cookies for essential site functionality (cart, checkout,
        regional pricing), performance analytics, and limited advertising attribution. You can
        manage or block cookies through your browser settings.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        5. Your rights
      </h2>
      <p>
        Depending on where you live (PIPEDA for Canada, GDPR for the EU/UK, CCPA for California),
        you may have the right to access, correct, delete, port, or restrict processing of your
        personal data, and to withdraw consent. To exercise these rights, write to{" "}
        <a className="underline" href="mailto:info@smibhaluxecandles.com">info@smibhaluxecandles.com</a>.
        We respond within 30 days.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        6. Data retention &amp; security
      </h2>
      <p>
        We retain personal data only as long as necessary to deliver our Services and comply with
        legal obligations (typically up to 7 years for transaction records). All data is encrypted
        in transit (TLS 1.2+) and at rest in our managed databases.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        7. Children
      </h2>
      <p>
        Our Services are not directed at children under 13, and we do not knowingly collect
        personal information from them.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        8. Changes to this policy
      </h2>
      <p>
        We may update this Privacy Policy from time to time. Material changes will be highlighted
        on this page and, where appropriate, communicated by email.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        9. Contact
      </h2>
      <p>
        Smibha Luxe Candles · 21 Whittaker Cres, Cambridge, ON N1T 1Z4, Canada ·{" "}
        <a className="underline" href="mailto:info@smibhaluxecandles.com">info@smibhaluxecandles.com</a>
      </p>

      <p className="text-sm text-zinc-500 mt-10">
        This document is provided as a professional placeholder. Please have a qualified attorney
        review it before relying on it for compliance in your jurisdiction.
      </p>
    </PolicyPage>
  );
}
